import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/cookie-settings/page.tsx");
